// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1i4cJ","footer":"ModalError_footer__gsm9k"};